export const translations = {
  es: {
    nav: {
      industries: 'Industrias',
      aiAgents: 'Agentes IA',
      about: 'Nosotros',
      partners: 'Partners',
      resources: 'Recursos',
      login: 'Iniciar Sesión',
      tryGervis: 'Prueba GERVIS'
    },
    hero: {
      announcement: '🚀 Contacta leads en menos de 1 minuto',
      title: 'Delega las conversaciones con clientes a los',
      titleHighlight: 'agentes-IA',
      subtitle: 'Deja que GERVIS atienda a tus clientes. Sin errores. Siempre conectado a tu CRM.',
      cta: 'Prueba GERVIS'
    },
    services: {
      badge: '¿Qué hacemos?',
      title: 'Múltiples-IA',
      titleEnd: 'para tu negocio',
      subtitle: 'GERVIS ofrece agentes digitales que realizan las tareas repetitivas por ti. Se integran con tu CRM, llenan los datos automáticamente y mantienen todo organizado.',
      speedToLead: {
        title: 'Speed to Lead',
        subtitle: 'Agente de Voz',
        description: 'Contacta leads entrantes de anuncios pagados, redes sociales y formularios registrados. Llamadas automáticas dentro del primer minuto de registro.'
      },
      textAgent: {
        title: 'Agente de Seguimiento',
        subtitle: 'Agente de Texto',
        description: 'Conversaciones de seguimiento automatizadas para cerrar ventas. Respuestas inteligentes y personalizadas para cada prospecto.'
      },
      recovery: {
        title: 'Recuperación de Leads',
        subtitle: 'Agente Outbound',
        description: 'Recupera todos los leads a través de llamadas y mensajes de texto salientes. Reactivación inteligente de oportunidades perdidas.'
      }
    },
    integrations: {
      title: 'Integrado a las mejores herramientas'
    },
    team: {
      badge: 'Conoce a nuestros Agentes IA',
      title: 'Conoce a nuestro equipo de especialistas digitales listos para asumir tareas clave y llevar tus proyectos al siguiente nivel.'
    },
    cta: {
      title: '¿Listo para transformar tu negocio?',
      subtitle: 'Comienza a usar GERVIS hoy y experimenta el poder de los agentes IA.',
      button: 'Solicitar Demo'
    },
    footer: {
      sitemap: 'Mapa del sitio',
      industries: 'Industrias',
      resources: 'Recursos',
      legal: 'Legales',
      home: 'Inicio',
      partners: 'Partners',
      cases: 'Casos de éxito',
      industriesPages: 'Industrias',
      api: 'API',
      jobs: 'Empleos',
      automotive: 'Automotriz',
      education: 'Educación',
      realestate: 'Inmobiliario',
      retail: 'Retail',
      health: 'Salud',
      insurance: 'Seguros',
      services: 'Servicios',
      blog: 'Blog',
      press: 'Prensa',
      community: 'Comunidad AI Explorers',
      roiCalc: 'Calculadora de ROI',
      whatsappGen: 'WhatsApp Link Generator',
      qrGen: 'WhatsApp QR Generator',
      helpCenter: 'Centro de ayuda',
      privacy: 'Políticas de privacidad',
      terms: 'Términos de uso',
      copyright: 'Copyright © 2025, GERVIS'
    },
    contact: {
      title: 'Contáctanos',
      subtitle: 'Estamos aquí para ayudarte a transformar tu negocio',
      name: 'Nombre',
      email: 'Email',
      phone: 'Teléfono',
      company: 'Empresa',
      message: 'Mensaje',
      submit: 'Enviar',
      success: 'Mensaje enviado exitosamente',
      error: 'Error al enviar el mensaje'
    }
  },
  en: {
    nav: {
      industries: 'Industries',
      aiAgents: 'AI Agents',
      about: 'About',
      partners: 'Partners',
      resources: 'Resources',
      login: 'Login',
      tryGervis: 'Try GERVIS'
    },
    hero: {
      announcement: '🚀 Contact leads in less than 1 minute',
      title: 'Delegate customer conversations to',
      titleHighlight: 'AI-agents',
      subtitle: 'Let GERVIS handle your customers. Error-free. Always connected to your CRM.',
      cta: 'Try GERVIS'
    },
    services: {
      badge: 'What we do?',
      title: 'Multiple-AI',
      titleEnd: 'for your business',
      subtitle: 'GERVIS offers digital agents that perform repetitive tasks for you. They integrate with your CRM, fill in data automatically and keep everything organized.',
      speedToLead: {
        title: 'Speed to Lead',
        subtitle: 'Voice Agent',
        description: 'Contact inbound leads from paid ads, social media and registered forms. Automatic calls within the first minute of registration.'
      },
      textAgent: {
        title: 'Follow-up Agent',
        subtitle: 'Text Agent',
        description: 'Automated follow-up conversations to close sales. Smart and personalized responses for each prospect.'
      },
      recovery: {
        title: 'Lead Recovery',
        subtitle: 'Outbound Agent',
        description: 'Recover all leads through outbound calls and text messages. Smart reactivation of lost opportunities.'
      }
    },
    integrations: {
      title: 'Integrated with the best tools'
    },
    team: {
      badge: 'Meet our AI Agents',
      title: 'Meet our team of digital specialists ready to take on key tasks and take your projects to the next level.'
    },
    cta: {
      title: 'Ready to transform your business?',
      subtitle: 'Start using GERVIS today and experience the power of AI agents.',
      button: 'Request Demo'
    },
    footer: {
      sitemap: 'Sitemap',
      industries: 'Industries',
      resources: 'Resources',
      legal: 'Legal',
      home: 'Home',
      partners: 'Partners',
      cases: 'Success Cases',
      industriesPages: 'Industries',
      api: 'API',
      jobs: 'Jobs',
      automotive: 'Automotive',
      education: 'Education',
      realestate: 'Real Estate',
      retail: 'Retail',
      health: 'Health',
      insurance: 'Insurance',
      services: 'Services',
      blog: 'Blog',
      press: 'Press',
      community: 'AI Explorers Community',
      roiCalc: 'ROI Calculator',
      whatsappGen: 'WhatsApp Link Generator',
      qrGen: 'WhatsApp QR Generator',
      helpCenter: 'Help Center',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
      copyright: 'Copyright © 2025, GERVIS'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We are here to help you transform your business',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      message: 'Message',
      submit: 'Submit',
      success: 'Message sent successfully',
      error: 'Error sending message'
    }
  }
};